export default "__VITE_ASSET__7b4377a5__"